<!--The content below is only a placeholder and can be replaced.-->

<colsubsidio-ciam-active-directory
ngClass="w-50"
[api_key]="apiKey"
[type_marketing]="typeMarketing"
[var_userdata]="varUserData"
[screen_prefix]="screenPrefix"
[cdn_url]="cdnUrl"
[url_authentication_ciam]="urlAuthenticationCiam"
[count_auth]="countAuth"
(result_auth)="redirectUrl($event)"
></colsubsidio-ciam-active-directory>
<div *ngIf="mostrarContenido">
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
  <notifier-container></notifier-container>

  <router-outlet></router-outlet>

</div>
<div *ngIf="!mostrarContenido">
  <a href="https://www.youtube.com/watch?si=OAjaVg4PlXdb0nrs&v=qMjIN9EX2JM&feature=youtu.be" target="_blank">
    <img *ngIf="isMobile" src="assets/images/home-portalempresas-mobile.jpg" class="responsive-home-image">
    <!-- Imagen para computadoras -->
    <img *ngIf="!isMobile" src="assets/images/home-portalempresas-desktop.jpg" class="responsive-home-image">
  </a>
</div>
